import { useTranslation } from 'react-i18next'

import { InputSection, LabelSize } from 'aem-libs-react-components/src/components/calculators/components/input-section'
import { PlusMinusNumberField } from 'aem-libs-react-components/src/components/forms/plus-minus-number-field'
import { PlusMinusSliderField } from 'aem-libs-react-components/src/components/forms/plus-minus-slider-field'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import { trackingKeys } from '../constants'
import { testIds } from '../e2e/testIds'
import { useLoanDurationMax } from '../hooks/useLoanDurationMax'
import { loansConsolidationStore } from '../store'
import type { LoansConsolidationParams } from '../types'

export const InputFields = () => {
  const { t } = useTranslation()
  const params = useDynamicParams<LoansConsolidationParams>()
  const { loanDurationMax, loanDurationMaxParams } = useLoanDurationMax()

  const values = loansConsolidationStore.useStoreData()
  const actions = loansConsolidationStore.useStoreActions()

  return (
    <InputSection.Container>
      <InputSection.Row
        id={trackingKeys.remainingLoanValueId}
        labelSize={LabelSize.MEDIUM_LARGE}
        label={t('INPUTS.AMOUNT')}
      >
        <PlusMinusSliderField
          id={trackingKeys.remainingLoanValueId}
          trackingDescription={trackingKeys.remainingLoanValue}
          unitType='czk'
          value={values.loanAmount}
          onChangeComplete={(value) => actions.setLoanAmount(value, loanDurationMaxParams)}
          width='long'
          responsive
          testId={testIds.loanInputBase}
          {...params.loanInputConfig}
          min={values.monthlyPayment > params.loanInputConfig.min ? values.monthlyPayment : params.loanInputConfig.min}
        />
      </InputSection.Row>
      <InputSection.Row
        id={trackingKeys.consolidatedLoansInstallmentsId}
        label={t('INPUTS.MONTHLY_PAYMENT')}
        labelSize={LabelSize.MEDIUM_LARGE}
      >
        <PlusMinusNumberField
          id={trackingKeys.consolidatedLoansInstallmentsId}
          trackingDescription={trackingKeys.consolidatedLoansInstallments}
          unitType='czk'
          value={values.monthlyPayment}
          onChangeComplete={(value) => actions.setMonthlyPayment(value)}
          width='long'
          responsive
          testId={testIds.monthlyPaymentBase}
          {...params.paymentInputConfig}
          max={values.loanAmount < params.paymentInputConfig.max ? values.loanAmount : params.paymentInputConfig.max}
        />
      </InputSection.Row>

      <InputSection.Row labelSize={LabelSize.MEDIUM_LARGE} label={t('INPUTS.EXTRA_LOAN')}>
        <PlusMinusSliderField
          id={trackingKeys.additionalMoneyId}
          trackingDescription={trackingKeys.additionalMoney}
          unitType='czk'
          value={values.extraLoanAmount}
          onChangeComplete={(value) => actions.setExtraLoanAmount(value, loanDurationMaxParams)}
          width='long'
          responsive
          testId={testIds.extraLoanBase}
          {...params.extraLoanInputConfig}
        />
      </InputSection.Row>
      <InputSection.Row
        id={trackingKeys.loanDurationId}
        label={t('INPUTS.DURATION')}
        labelSize={LabelSize.MEDIUM_LARGE}
      >
        <PlusMinusSliderField
          id={trackingKeys.loanDurationId}
          trackingDescription={trackingKeys.loanDuration}
          unitType='years'
          value={values.loanDuration}
          onChangeComplete={(value) => actions.setLoanDuration(value)}
          width='long'
          responsive
          testId={testIds.loanDurationBase}
          {...params.loanDurationInputConfig}
          max={loanDurationMax}
        />
      </InputSection.Row>
    </InputSection.Container>
  )
}
